import React, { useEffect, useRef } from 'react';

import st from './WsVideoPlayer.module.sass';

class WSPlayer {
  constructor(node, wsUrl) {
    this.node = node;
    this.wsUrl = wsUrl;
    this.queue = [];
  }

  async initMediaSource() {
    this.mediaSource = new MediaSource();
    this.node.src = URL.createObjectURL(this.mediaSource);

    return new Promise((resolve) => {
      this.mediaSource.addEventListener('sourceopen', () => {
        this.sourceBuffer = this.mediaSource.addSourceBuffer('video/mp4; codecs="avc1.4D002A"');
        this.sourceBuffer.mode = 'sequence';

        this.sourceBuffer.addEventListener('update', () => {
          if (this.queue.length > 0 && !this.sourceBuffer.updating) {
            this.sourceBuffer.appendBuffer(this.queue.shift());
          }
        });

        resolve();
      });
    });
  }

  async play() {
    await this.initMediaSource();
    try {
      this.ws = new WebSocket(this.wsUrl);
      this.ws.binaryType = 'arraybuffer';

      this.ws.onmessage = (event) => {
        let { data } = event;

        if (!(data instanceof ArrayBuffer)) {
          try {
            data = new Uint8Array(data).buffer;
          } catch (e) {
            console.error(`[WSPlayer] Data conversion error: ${e.message}`);
            return;
          }
        }

        if (this.sourceBuffer.updating || this.queue.length > 0) {
          this.queue.push(data);
        } else {
          if (this.mediaSource.readyState !== 'open') {
            console.warn('[WSPlayer] MediaSource closed, closing ws');
            this.ws.close();
            return;
          }
          this.sourceBuffer.appendBuffer(data);
        }
      };

      this.ws.onerror = (err) => {
        console.error(`[WSPlayer] WebSocket error: ${err.message || JSON.stringify(err)}`);
      };
    } catch (e) {
      console.error(`[WSPlayer]: WebSocket connection error: ${e.message}`);
    }
  }
}

export const WsVideoPlayer = ({ wsUrl, autoPlay }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!wsUrl || !video) return () => {};

    const player = new WSPlayer(videoRef.current, wsUrl);
    player.play();

    return () => {
      player.ws?.close();
    };
  }, [wsUrl]);

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/media-has-caption
    <video
      autoPlay={autoPlay}
      className={st.Video}
      controls
      ref={videoRef}
    />
  );
};
